import * as R from 'ramda';
import React, { useState, Fragment } from 'react';
// components
import { TextComponent } from '../../../components/text';
// helpers/constants
import * as G from '../../../helpers';
import * as GC from '../../../constants';
// ui
import { Flex, ReactSelect, AbsoluteBox } from '../../../ui';
// utilities
import { sendRequest } from '../../../utilities/http';
import endpointsMap from '../../../utilities/endpoints';
// feature rate
import { mapAvailableTrailersToOptions } from '../helpers';
//////////////////////////////////////////////////

const formatOptionLabel = ({ lnl, label, distance }) => (
  <Flex alignItems='start' flexDirection='column'>
    {[label, distance, lnl].map((item, i) => (
      <TextComponent key={i} title={item} maxWidth='100%' withEllipsis={true}>
        {item}
      </TextComponent>
    ))}
  </Flex>
);

const ShowAllComponent = ({ handleGetTrailersRequest }) => (
  <AbsoluteBox top={-15} right='5px'>
    <Flex
      fontSize={12}
      cursor='pointer'
      color={G.getTheme('colors.dark.blue')}
      onClick={() => handleGetTrailersRequest(true)}
    >
      {G.getWindowLocale('titles:show-all', 'Show All')}
    </Flex>
  </AbsoluteBox>
);

export const SelectFleetTrailer = (props) => {
  const {
    value,
    events,
    telGuid,
    fieldName,
    branchGuid,
    setFieldValue,
    preselectedTrailers,
    selectedFleetTrailer,
    setSelectedFleetTrailer,
  } = props;

  const [isLoading, setIsLoading] = useState(false);
  const [availableTrailers, setAvailableTrailers] = useState(null);

  let options = R.or(availableTrailers, []);

  if (G.isNotNilAndNotEmpty(selectedFleetTrailer)) {
    options = R.compose(
      R.uniqBy(R.prop(GC.FIELD_VALUE)),
      R.append(selectedFleetTrailer),
    )(options);
  }

  const handleGetTrailersRequest = async (showAll) => {
    setIsLoading(true);

    try {
      let res = {};

      if (G.isNotNilAndNotEmpty(telGuid)) {
        const params = { telGuid, showAll };

        res = await sendRequest('get', endpointsMap.availableTrailers, { params });
      } else if (G.isAllNotNilOrNotEmpty([events, branchGuid])) {
        const reqData = {
          data: {
            events,
            showAll,
            [GC.FIELD_BRANCH_GUID]: branchGuid,
          },
        };

        res = await sendRequest('post', endpointsMap.telCarrierAssignmentAvailableTrailers, reqData);
      }

      const { data, status } = res;

      if (G.isResponseSuccess(status)) {
        setAvailableTrailers(mapAvailableTrailersToOptions(data));
      } else if (G.isNotNilAndNotEmpty(res)) {
        G.handleFailResponseSimple(res);
      }
    } catch (e) {
      G.handleException('error', 'handleGetTrailersRequest exception');
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (value) => {
    const trailerValue = R.isNil(value) ? null : G.getValueFromObject(value);

    setSelectedFleetTrailer(value);
    setFieldValue(fieldName, trailerValue);
  };

  const handleMenuOpen = () => {
    if (R.isNil(availableTrailers)) handleGetTrailersRequest();
  };

  return (
    <Fragment>
      <ReactSelect
        value={value}
        id={fieldName}
        options={options}
        isClearable={true}
        isLoading={isLoading}
        onChange={handleChange}
        useMenuPortalTarget={true}
        onMenuOpen={handleMenuOpen}
        formatOptionLabel={formatOptionLabel}
      />
      {
        G.isNotNilAndNotEmpty(G.getAmousConfigByNameFromWindow(GC.TEL_RATE_TRAILER_DEFAULT_SEARCH_RADIUS)) &&
        <ShowAllComponent handleGetTrailersRequest={handleGetTrailersRequest} />
      }
    </Fragment>
  );
};
